export default __webpack_public_path__ + "static/1018-14461ef31f61a050382b3b1bcfa6311e.gif";